module.exports = __webpack_public_path__ + "img/banner-mob.8f7a6824.png";